import { useState } from 'react';
import Sheet from '../Sheet';
import ButtonSpinner from '../ButtonSpinner';
import { BTN_SECONDARY } from '../buttonStyles';
import { useToast } from '../../hooks/useToast';
import { liveLessonsErrorMessage, refundLiveMissedLesson } from '../../services/liveLessons';
import { busyStyle } from '../../utils/busyStyle';
import { TEXT_ACTION_DESTRUCTIVE } from './surfaces';

/**
 * Refund instead (decision 84), from the support message or the missed
 * lesson's page: the held lesson's payment back in full, and the lesson no
 * longer held. Asked once, as the Cancel sheet asks: a grey Keep the Lesson
 * and the one red action.
 */
export function RefundMissedSheet({ bookingId, onClose }: { bookingId: string; onClose: (refunded?: boolean) => void }) {
  const { showError, showSuccess } = useToast();
  const [busy, setBusy] = useState(false);
  const refund = async () => {
    setBusy(true);
    try {
      await refundLiveMissedLesson({ bookingId });
      showSuccess('Refund issued.');
      onClose(true);
    } catch (err) {
      showError(liveLessonsErrorMessage(err, 'Could not refund this lesson. Please try again.'));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Sheet title="Refund instead?" onClose={() => onClose()} busy={busy} dismissLabel="Close">
      <p className="text-[17px] leading-[22px] tracking-[-0.43px] text-db-text-1">
        You get a full refund, and this lesson is no longer held for you.
      </p>
      <button type="button" onClick={() => onClose()} disabled={busy} className={`${BTN_SECONDARY} mt-6 w-full`}>
        Keep the Lesson
      </button>
      <button type="button" onClick={() => { void refund(); }} disabled={busy} aria-busy={busy} style={busyStyle(busy)}
        className={`${TEXT_ACTION_DESTRUCTIVE} mb-2 mt-2`}>
        {busy ? <ButtonSpinner size={18} /> : 'Refund'}
      </button>
    </Sheet>
  );
}
